// src/pages/SingleListingGenerator/constants.js
// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Listing Generator Constants
export const MAX_IMAGES = 5;
export const MAX_APP_IMAGES = 1;
export const TEMPLATE_COUNT = 25;
export const MAX_VARIATIONS = 3;
export const SINGLE_GEN_COST = 1;
export const MAX_BULLETS = 10;

// Configuration for theme images
export const THEME_CONFIG = {
    theme1: { bplus: [1, 2, 3, 4, 5, 6], zoomshot: 7, aplus: [7, 8, 9, 10, 11] },
    theme2: { bplus: [1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10, 11] },
    theme3: { bplus: [1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10] },
    theme4: { bplus: [1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10, 11] },
    theme5: { bplus: [1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10] },
    theme6: { bplus: [1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10,11] },
    theme7: { bplus: [1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10, 11] },
    theme8: { bplus: [1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10,11] },
    theme9: { bplus: [2, 3, 4, 5, 6, 7], aplus: [9, 10, 11, 12, 13] },
    theme10: { bplus: [2, 3, 4, 5, 6, 7], aplus: [9, 10, 11, 12, 13] },
    theme11: { bplus: [1, 2, 3, 4, 5, 6], aplus: [8, 9, 10, 12] },
    theme12: { bplus: [1, 2, 3, 4, 5, 6], aplus: [8, 9, 10, 11] },
    theme13: { bplus: [1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10] },
    theme21: { bplus: [1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10, 11] },
    //theme 14 to theme 20
    theme14: { bplus: [1, 2, 3, 4, 5, 7], aplus: [8, 9, 10, 11] },
    theme15: { bplus: [1, 2, 3, 4, 5, 7], aplus: [8, 9, 10, 11] },
    theme16: { bplus: [1, 2, 3, 4, 5, 7], aplus: [8, 9, 10, 11] },
    theme17: { bplus: [1, 2, 3, 4, 5, 7], aplus: [8, 9, 10, 11] },
    theme18: { bplus: [1, 2, 3, 4, 5, 7], aplus: [8, 9, 10, 11, 12] },
    theme19: { bplus: [1, 2, 3, 4, 5, 7], aplus: [8, 9, 10, 11, 12] },
    theme20: { bplus: [1, 2, 3, 4, 5, 7], aplus: [8, 9, 10, 11, 12] },
    theme22: {bplus:[1, 2, 3, 4, 5, 6], aplus: [8, 9, 10, 11, 12]},
    theme23: {bplus:[1, 2, 3, 4, 5, 6], aplus: [8, 9, 10, 11, 12]},
    theme24: {bplus:[1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10, 11]},
    theme25: {bplus:[1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10, 11]},
    theme28:{bplus:[1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10, 11]},
    theme29:{bplus:[1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10, 11]},
    theme30:{bplus:[1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10, 11]},
    theme31:{bplus:[1, 2, 3, 4, 5, 6], aplus: [7, 8, 9, 10, 11]},
    theme32:{bplus:[1, 2, 3, 4, 5, 6, 7], aplus: [8, 9, 10, 11, 12]},
};

// Configuration for A+ pages that don't need images
export const APLUS_NO_IMAGE_CONFIG = {
    theme1: { 0: true, 1: false, 2: true, 3: true, 4: true },
    theme2: { 0: true, 1: false, 2: true, 3: false, 4: true },
    theme3: { 0: true, 1: true, 2: true, 3: false },
    theme4: { 0: true, 1: true, 2: true, 3: false, 4: false },
    theme5: { 0: true, 1: true, 2: true, 3: false },
    theme6: { 0: true, 1: true, 2: true, 3: true, 4: false },
    theme7: { 0: true, 1: true, 2: true, 3: true, 4: false },
    theme8: { 0: true, 1: true, 2: false, 3: false, 4: true },
    theme9: { 0: true, 1: true, 2: true, 3: true, 4: false },
    theme10: { 0: true, 1: true, 2: true, 3: true, 4: false },
    theme11: { 0: true, 1: true, 2: true, 3: false },
    theme12: { 0: true, 1: true, 2: true , 3: false},
    theme13: { 0: true, 1: true, 2: true, 3: false },
    theme21: { 0: true, 1: true, 2: true, 3: true, 4: false },

    theme14: {0: true, 1: true, 2: false, 3: true },
    theme15: { 0: true, 1: true, 2: false, 3: true , 4:false},
    theme16: { 0: true, 1: true, 2: true, 3: false },
    theme17: { 0: true, 1: true, 2: true, 3: false },
    theme18: { 0: true, 1: true, 2: true, 3: false, 4: true},
    theme19: { 0: true, 1: true, 2: true, 3: true, 4: false },
    theme20: { 0: true, 1: true, 2: true, 3: true, 4: false },

    theme22:{ 0: true, 1: true, 2: true, 3: false, 4: false},
    theme23:{ 0: true, 1: true, 2: true, 3: false, 4: true},
    theme24:{ 0: true, 1: true, 2: true, 3: false, 4: true},
    theme25:{ 0:true, 1:true, 2:true, 3:false, 4:true},

    theme28:{ 0: true, 1: true, 2: true, 3: false, 4: true},
    theme29:{ 0: true, 1: true, 2: true, 3: false, 4: true},
    theme30:{ 0: true, 1: true, 2: false, 3: true, 4: false},
    theme31:{ 0: true, 1: true, 2: false, 3: true, 4: false},
    theme32:{ 0: false, 1: true, 2: true, 3: true, 4: true},

};

// Derived constant for max product images per theme
// B+ Product Limit = total bplus thumbnails - 2 (placeholders)
// A+ Product Limit = count of 'true' values in APLUS_NO_IMAGE_CONFIG
export const THEME_IMAGE_COUNT = Object.keys(THEME_CONFIG).reduce((acc, theme) => {
    const bPlusLimit = THEME_CONFIG[theme].bplus.length - 2;
    const aPlusLimit = Object.values(APLUS_NO_IMAGE_CONFIG[theme]).filter(Boolean).length;
    acc[theme] = { bplus: bPlusLimit, aplus: aPlusLimit };
    return acc;
}, {});

// Initial Form States
export const initialNewFormData = {
    brandName: '', category: '', subCategory: '', productType: '', briefDescription: '', keywords: '', 
    bannedKeywords:'', modelNumber: '', skuId: '', color: '', material: '', size: '', eanNumber: '',
    feature1: '', feature2: '', feature3: '', feature4: '', feature5: '', projectName: '',
    benefits: '', usage: '', instructions: '',
};

export const initialExistingInput = {
    asin: '',
    title: '',
    bullets: ['', '', '', '', ''], 
    description: ''
};